import { useQuery } from '@tanstack/react-query';
import { OrdersSalesQueryKeys } from '@enums/react-query-keys';
import { Timeline } from '@interfaces/models/timeline';
import { ResponseResult, getTimeline } from '@services/my-orders-sales-service';
import useUser from '@hooks/user/use-user';

const useTimelineQuery = (productId: string, orderId: string | null, enabled?: boolean) => {
  const { userId, isAuthenticated } = useUser();

  const isEnabled = enabled !== undefined ? isAuthenticated && enabled : isAuthenticated;

  const { error, isFetching, data, refetch } = useQuery<ResponseResult<Timeline>>({
    queryKey: [OrdersSalesQueryKeys.TIMELINE, userId, isAuthenticated, productId, orderId],
    queryFn: () => {
      return getTimeline(productId, orderId);
    },
    staleTime: 0,
    cacheTime: 0,
    enabled: isEnabled,
  });

  const isErrorTimeline = error != null || (data && data.kind !== 'Success');
  const timeline = data && data.kind === 'Success' ? data.data : null;

  return { isErrorTimeline, isLoadingTimeline: isFetching, timeline, refetchTimeline: refetch };
};

export default useTimelineQuery;
